import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';

import { useSetFilters } from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import type { FilterQuery, VehicleListFilterQuery } from 'Types/filter';

import { useCalculateFiltersFromQuery } from './useCalculateFiltersFromQuery';
import { useCalculateQueryFromFilters } from './useCalculateQueryFromFilters';

const useVehicleListFilterQuery = (query: VehicleListFilterQuery): FilterQuery => {
	const setFilters = useSetFilters();
	const calculatedQueryFromFilters = useCalculateQueryFromFilters();
	const calculatedFiltersFromQuery = useCalculateFiltersFromQuery(query);

	useEffect(() => {
		if (isEmpty(query)) {
			return;
		}
		setFilters({ filters: calculatedFiltersFromQuery });
	}, [calculatedFiltersFromQuery, setFilters, query]);

	return calculatedQueryFromFilters;
};

export default useVehicleListFilterQuery;
